module.exports = __webpack_public_path__ + "static/img/jjDriver.640dc480.png";